import axios from "axios";
import { data } from "brands/opopular/assets/data";
import { get } from "lodash";

export const castContentIdString = (contentId) => {
  const replacements = [
    { from: "contentid/", to: "" },
    { from: "policy:/", to: "" },
    { from: "policy:", to: "" },
  ];

  let contentIdString = contentId || "";

  replacements?.map((r) => {
    contentIdString = contentIdString.replace(r.from, r.to);
  });

  return contentIdString;
};

export const fetchApi = async (url) => {
  try {
    const res = await fetch(url);
    return res.json();
  } catch (e) {
    console.log("e", e);
    return [];
  }
};

export const postFetchApi = async (url, payload) => {
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return res.json();
  } catch (e) {
    console.log("e", e);
    return [];
  }
};

export const deleteApiPaywall = async (url) => {
  return await axios
    .delete(url)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const res = get(err, "response.data", {});
      return res;
    });
};

export const postApiPaywall = async (url, body) => {
  return await axios
    .post(url, body, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const res = get(err, "response.data", {});
      console.log("err", res);
      return res;
    });
};

export const patchCreditsEarnedPaywall = async (url) => {
  return await axios
    .patch(url, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const res = get(err, "response.data", {});
      console.log("err", res);
      return res;
    });
};

export const postApi = async (url, body) => {
  return await axios
    .post(url, body, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      const res = get(err, "response.data", {});
      console.log("err", res);
      return res;
    });
};
